import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import { supportedLanguages } from './languages';

export {
  languageNames,
  pendingUiLanguages,
  supportedLanguages,
  uiLanguages,
  type SupportedLanguage,
} from './languages';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fi',
    supportedLngs: supportedLanguages,
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already escapes
    },

    backend: {
      // Cache-bust locale files per build so new/changed translations show up
      // after a deploy instead of serving a browser-cached JSON (the files are
      // static, non-hashed assets). __APP_VERSION__ is a build-time define
      // (unique per deploy); guard with typeof so tests without the define load.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${encodeURIComponent(
        typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev',
      )}`,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'staff-portal-lang',
    },

    // inventoryCosting, inventoryReports and partPricing belong to the Inventory page's costing, reports and pricing tabs
    // (and the stock-adjustment dialog): preloaded so those screens never paint a raw key while the files load.
    // procurementDispatch, procurementReceiving and procurementInvoices belong to the purchase order detail and the supplier dispatch settings (preloaded for the same reason).
    ns: ['common', 'dashboard', 'calendar', 'workorders', 'navigation', 'inspection', 'approvals', 'messages', 'settings', 'persons', 'companies', 'parties', 'vehicles', 'inventory', 'inventoryCosting', 'inventoryReports', 'partPricing', 'procurementDispatch', 'procurementReceiving', 'procurementInvoices', 'reports', 'hr', 'assistant', 'guides', 'shifts', 'equipment', 'invoices', 'checklists', 'workpaths', 'exceptions', 'demo', 'signup', 'automation', 'onboarding', 'copaya', 'releases', 'releaseApproval'],
    defaultNS: 'common',
  });

export default i18n;
